"use client";

import { SectionHeader } from "@/components/ui/SectionHeader";
import { TestimonialCard } from "@/components/ui/TestimonialCard";
import { landingContent } from "@/content/landing";

interface TestimonialsV2Props {
  className?: string;
}

export function TestimonialsV2({ className = "" }: TestimonialsV2Props) {
  const testimonials = landingContent.testimonials.items;

  return (
    <section id="testimonials" className={`relative flex flex-col items-center gap-[40px] py-[80px] overflow-hidden ${className}`}>
      {/* Soft airy brand glow centred horizontally and vertically: a single radial ellipse fading to
          fully transparent toward the left/right edges (white at the section margins) and toward the
          top/bottom edges, so it reads as a soft centred wash rather than a full-width plate. Almost no
          tint sits directly behind the heading. No hard seam, no flat fill. Same on every breakpoint. */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 62% 56% at 50% 50%, var(--brand-primary-soft) 0%, rgba(255,255,255,0) 72%)",
        }}
      />

      <SectionHeader className="relative z-[1]"
        title={landingContent.testimonials.title}
        subtitle={landingContent.testimonials.subtitle}
      />

      {/* Desktop: 3 cards in a row */}
      <div className="relative z-[1] flex gap-[16px] w-full max-w-[1248px] px-[16px] max-desktop:hidden">
        {testimonials.map((t) => (
          <TestimonialCard
            key={t.name}
            quote={t.quote}
            avatar={t.avatar}
            name={t.name}
            role={t.role}
          />
        ))}
      </div>

      {/* Tablet + Mobile: horizontal scroll carousel */}
      <div
        className="no-scrollbar relative z-[1] hidden max-desktop:flex gap-[16px] w-full overflow-x-auto px-[20px]"
        style={{
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {testimonials.map((t) => (
          <div key={t.name} style={{ scrollSnapAlign: "start", flexShrink: 0, width: 399 }}>
            <TestimonialCard
              quote={t.quote}
              avatar={t.avatar}
              name={t.name}
              role={t.role}
              className="w-full"
            />
          </div>
        ))}
        {/* trailing spacer so last card doesn't flush to edge */}
        <div style={{ flexShrink: 0, width: 4 }} />
      </div>
    </section>
  );
}
